import styled from 'styled-components';

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  max-width: 500px;
  max-height: 70vh;
  overflow-y: auto;
  font-family: ${({ theme }) => theme?.fonts?.main || 'Arial, sans-serif'};
  color: ${({ theme }) => theme?.colors?.text || '#333'};
`;

export const Title = styled.h2`
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 16px;
  color: ${({ theme }) => theme?.colors?.text || '#333'};
  line-height: 1.4;
`;

export const SuccessMessage = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme?.colors?.success || '#28a745'};
  margin-bottom: 12px;
`;

export const CheckIcon = styled.span`
  font-size: 18px;
`;

export const IntroText = styled.p`
  font-size: 16px;
  margin-bottom: 16px;
  line-height: 1.5;
  text-align: center;
`;

export const ImportantSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ImportantItem = styled.div`
  line-height: 1.4;
  margin-bottom: 12px;
`;

export const ImportantText = styled.span`
  font-size: 14px;
  display: block;
`;

export const FielTorcedorButton = styled.button`
  background-color: ${({ theme }) => theme?.colors?.primary || '#007bff'};
  color: white;
  border: none;
  padding: 14px 20px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
  text-align: center;
  width: 100%;
  max-width: 400px;

  &:hover {
    background-color: ${({ theme }) => theme?.colors?.primaryHover || '#0056b3'};
  }
`;

export const ButtonSection = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`;

export const WarningFooter = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #e67e22;
  background-color: #fef5e7;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #f39c12;
  margin-bottom: 20px;
`;

export const WarningIcon = styled.span`
  font-size: 16px;
  flex-shrink: 0;
`;

